import { Injectable } from "@angular/core";
import { Adapter } from "@core/adapter";
import { Series } from "./series.model";

export class Course{
  constructor(
    public id:string,
    public name:string = "",
    public series:Series[] = [],
    public requirementsMet:boolean = true,
    public available:boolean = true,
    public description:string = ""
  ){}
}

export class CourseBundle{
  constructor(
    public id:string,
    public name:string,
    public description:string,
    public pricePerPerson:string,
    public fixedSeries:Array<Series>,
    public variableBundles:VariableSeriesBundle[] = [],
    public requirementsMet: boolean = true,
    public openForEnrolments: boolean = true
  ){}
}

export class VariableSeriesBundle{
  constructor(
    public id:string,
    public name:string,
    public series:Array<Series>,
    public requiredSelectionCount:number,
    public selectionType:string,
    public fixed:boolean = true
  ){}
}

@Injectable({
  providedIn: 'root'
})
export class CourseBundleAdapter implements Adapter<CourseBundle> {
  constructor(){}
  adapt(item: any): CourseBundle {
    return new CourseBundle(
      item.id,
      item.name,
      item.description,
      item.pricePerPerson,
      [],
      [],
      item.requirementsMet,
      item.openForEnrolments
    );
  }
}
